import React, {Fragment} from 'react';
import Component from 'components/component';
import {DI} from 'modules';

function Login(props) {
    const {strings} = props.common;

    const signIn = (ev) => {
        ev.preventDefault();
        props.actions.common.openSignInModal();
    };

    const signUp = (ev) => {
        ev.preventDefault();
        props.actions.common.openSignUpModal();
    };

    return (
        <Fragment>
            <div className={Component.classList("live-download", !props.withRestrictions && 'live-download--not-padded')}>
                <button type="button" className="button" onClick={signIn}>
                    {strings['page.video.left.download']}
                </button>
            </div>
            <div className="live-not-registered">
                <span className="live__not-registered">
                    {strings['page.video.left.no_account']}
                    <a href="#" onClick={signUp}>
                        {strings['page.video.left.sign_up']}
                    </a>
                </span>
            </div>
        </Fragment>
    );
}

export default DI(['common'])(Login);
